function notifyWishlistUpdated() {
  document.dispatchEvent(new CustomEvent('wishlist:updated'));
}

const productCache = {};
let wishlistRendering = false;
const WISHLIST_KEY = 'wishlist_items';

/* helpers */
function getWishlist() {
  const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];

  const clean = raw.filter(item =>
    item &&
    item.handle &&
    item.variantId &&
    Number(item.qty) > 0
  );

  if (clean.length !== raw.length) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));
  }

  return clean;
}

function saveWishlist(items) {
  const clean = items.filter(item =>
    item &&
    item.handle &&
    item.variantId &&
    Number(item.qty) > 0
  );

  localStorage.setItem(WISHLIST_KEY, JSON.stringify(clean));
  updateWishlistCount();
  notifyWishlistUpdated();
}

function updateWishlistCount() {
  const items = getWishlist();

  const count = items.reduce((sum, item) => {
    return sum + (parseInt(item.qty, 10) || 0);
  }, 0);

  const modalCount = document.getElementById('wishlistCount');

  // Modal title Wishlist (X)
  if (modalCount) {
    modalCount.textContent = `(${count})`;
  }
}


/* modal */
function openWishlist() {
  const modal = document.getElementById('wishlistModal');
  modal.classList.add('active');

  updateWishlistCount(); 
  renderWishlist();
}

function closeWishlist() {
  document.getElementById('wishlistModal').classList.remove('active');
}

/* fetch product */
async function fetchProduct(handle) {
  if (productCache[handle]) {
    return productCache[handle];
  }

  const res = await fetch(`/products/${handle}.js`);
  const data = await res.json();

  productCache[handle] = data;
  return data;
}

/* render */
async function renderWishlist() {
  if (wishlistRendering) return; // prevent double render
  wishlistRendering = true;

  const tbody = document.getElementById('wishlistTableBody');
  if (!tbody) {
    wishlistRendering = false;
    return;
  }

  tbody.innerHTML = '';

  const items = getWishlist();
  if (!items.length) {
    wishlistRendering = false;
    return;
  }

  for (const item of items) {
    try {
      const product = await fetchProduct(item.handle);
      if (!product || !product.variants) continue;

      const variant = product.variants.find(
        v => String(v.id) === String(item.variantId)
      );
      if (!variant) continue;

      const image =
        variant.featured_image?.src ||
        variant.featured_media?.preview_image?.src ||
        product.images?.[0] ||
        '';

      tbody.insertAdjacentHTML(
        'beforeend',
        `
        <tr data-variant-id="${variant.id}">
          <td>
            ${image ? `<img src="${image}" width="80" loading="lazy">` : ''}
          </td>

          <td>
            <a href="/products/${product.handle}">
              ${product.title}
            </a>
          </td>

          <td class="center">
            £${(variant.price / 100).toFixed(2)}
          </td>

          <td class="center">
            <div class="wishlist-qty">
              <button class="qty-btn qty-minus" data-variant-id="${variant.id}">−</button>
              <input
                type="number"
                min="1"
                value="${item.qty}"
                class="wishlist-qty-input"
                data-variant-id="${variant.id}"
              >
              <button class="qty-btn qty-plus" data-variant-id="${variant.id}">+</button>
            </div>
          </td>

          <td class="center">
            ${variant.title || 'Default'}
          </td>

          <td class="center">
            <div class="cart-close">
              <button
                class="wishlist-add-to-cart"
                data-variant-id="${variant.id}"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40">
                  <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"></path>
                </svg>
              </button>
              <button onclick="removeWishlist(${variant.id})">×</button>
            </div>
          </td>
        </tr>
        `
      );
    } catch (err) {
      console.error('Wishlist render error:', err);
    }
  }

  wishlistRendering = false; // unlock render
}


/* actions */
function addToWishlist(handle, variantId) {
  const items = getWishlist();
  const id = String(variantId);

  const exists = items.some(
    i => String(i.variantId) === id
  );

  if (!exists) {
    items.push({
      handle,
      variantId: id,
      qty: 1
    });
    saveWishlist(items);
  }

  const alert = document.getElementById('wishlistAlert');
  if (alert) {
    alert.innerHTML = `<div class="alert">Product added to wishlist successfully</div>`;
  }
  openWishlist();
}


function removeWishlist(variantId) {
  saveWishlist(getWishlist().filter(i => i.variantId != variantId));
  renderWishlist();
}

function updateWishlistQty(variantId, qty) {
  const items = getWishlist();
  const item = items.find(i => i.variantId == variantId);
  if (item) item.qty = parseInt(qty, 10);
  saveWishlist(items);
}

/* cart */
function addWishlistToCart(variantId, qty) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: qty
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(() => {
    removeWishlist(variantId);
    renderWishlist();      // refresh table
  })
  .catch(err => {
    console.error(err);
  });
}


document.addEventListener('click', e => {
  const cartBtn = e.target.closest('.wishlist-add-to-cart');
  if (!cartBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const row = cartBtn.closest('tr');
  const variantId = cartBtn.dataset.variantId;
  const qtyInput = row.querySelector('.wishlist-qty-input');
  const qty = parseInt(qtyInput.value, 10) || 1;

  addWishlistToCart(variantId, qty);
});
document.addEventListener('click', e => {
  const minus = e.target.closest('.qty-minus');
  const plus  = e.target.closest('.qty-plus');

  if (!minus && !plus) return;

  e.preventDefault();
  e.stopPropagation();

  const btn = minus || plus;
  const variantId = btn.dataset.variantId;
  const input = document.querySelector(
    `.wishlist-qty-input[data-variant-id="${variantId}"]`
  );

  let qty = parseInt(input.value, 10) || 1;

  if (minus && qty > 1) qty--;
  if (plus) qty++;

  input.value = qty;
  updateWishlistQty(variantId, qty);
});


/* events */
document.addEventListener(
  'click',
  function (e) {
    const heart = e.target.closest('.wishlist-heart');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      addToWishlist(
        heart.dataset.productHandle,
        heart.dataset.variantId
      );
      return;
    }

    if (
      e.target.classList.contains('wishlist-close') ||
      e.target.classList.contains('wishlist-overlay')
    ) {
      closeWishlist();
    }
  },
  true
);

updateWishlistCount();
document.querySelectorAll('.wishlist-hero-header-icon').forEach(el => {
  el.removeAttribute('href');
});
document.addEventListener(
  'pointerdown',
  function (e) {
    const headerWishlist = e.target.closest('.wishlist-hero-header-icon');
    if (!headerWishlist) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    openWishlist();
    renderWishlist();
  },
  true
);

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    updateWishlistCount();
  }, 0);
});